// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"125":"266ad179","925":"645c520b"}[chunkId] + ".css";
};